import React from "react";
import { connect } from "react-redux";
import TaggedStudentsForInternship from "../GALKRecruit/student/taggedStudentsForInternship";
import DetermineIntern from "../GALKRecruit/determineIntern";
import { withRouter } from "react-router-dom";
import RestrictedRoute from "../../utils/components/RestrictedRoute";
import ProjectInformation from "../GALKRecruit/projectInformation";
// import Watchlist from "../GALKRecruit/watchlist";
import Dashboard from "../GALKRecruit/dashboard";

const _intershipRoot = ({ match }) => {
	return (
		<>
			<RestrictedRoute exact path={`${match.path}/dashboard`}>
				<Dashboard />
			</RestrictedRoute>
			<RestrictedRoute exact path={`${match.path}/projectinformation`}>
				<ProjectInformation />
			</RestrictedRoute>
			{/* <RestrictedRoute exact path={`${match.path}/watchlist`}>
				<Watchlist />
			</RestrictedRoute> */}
			<RestrictedRoute exact path={`${match.path}/selectstudents`}>
				<TaggedStudentsForInternship />
			</RestrictedRoute>
			<RestrictedRoute exact path={`${match.path}/determineintern`}>
				<DetermineIntern />
			</RestrictedRoute>
		</>
	);
};

export default connect(null, {})(withRouter(_intershipRoot));
